// Created on 2021-04-10
// Copyright (c) 2021 Vilten s.r.o. - All Rights Reserved
// Unauthorized copying of this file, via any medium is strictly prohibited
// Proprietary and confidential
// Written by Viliam Tencer <vilten@vilten.sk>, 2021-04-10
import storage from './storage'

const auth = {
  logout: function () {
    console.log('logout call')
  },
  checkPIN: function (enteredPIN) {
    return enteredPIN === storage.getSettings('pin', '3321')
  },
  setPIN: function (enteredPIN) {
    return storage.setSettings('pin', enteredPIN)
  },
  hasPIN: function () {
    return storage.getSettings('pin') ? true : false
  },
  hasAuthPIN: function (cookies) {
    console.log(cookies.get('authPIN') ? true : false)
    return (cookies.get('authPIN') ? true : false && cookies.get('authPIN') === storage.getSettings('pin', '3321'))
  },
  authPIN: function (enteredPIN, cookies) {
    if (enteredPIN === storage.getSettings('pin', '3321')) {
      cookies.set('authPIN', enteredPIN, '10MIN')
      return true
    } else
      return false
  },
}

export default auth